import { useEffect, useRef } from 'react'

export function useRisingEdgeEffect({ value, onRisingEdge }) {
  const prevValueRef = useRef(value)
  const onRisingEdgeRef = useRef(onRisingEdge)

  useEffect(() => {
    onRisingEdgeRef.current = onRisingEdge
  }, [onRisingEdge])

  useEffect(() => {
    if (value && prevValueRef.current === false) {
      onRisingEdgeRef.current()
    }

    prevValueRef.current = value
  }, [value])
}
